import * as api from '../api';
import { getIsFetching } from '../reducers/insectsRef';

export const FETCH_INSECTS = 'intervention.FETCH_INSECTS';
export const FETCH_INSECTS_SUCCESS = 'intervention.FETCH_INSECTS_SUCCESS';

const requestInsectsRef = () => ({
  type: FETCH_INSECTS,
});

const receiveInsectsRef = refs => ({
  type: FETCH_INSECTS_SUCCESS,
  refs,
});

export const fetchInsectsRef = () => (dispatch, getState) => {
  const state = getState();
  if (getIsFetching(state)) {
    return Promise.resolve();
  }

  dispatch(requestInsectsRef());

  // Request interventions fetching then planning
  return api
    .getInsectSpeciesRef()
    .then(response => dispatch(receiveInsectsRef(response)));
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/actions/insectsRef.js